import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Markdown } from "@/components/Markdown";

const DEFAULT_TITLES = { terms: "Terms & Conditions", refunds: "Refund Policy", privacy: "Privacy Policy" };

export default function LegalPage({ pageKey }) {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/legal/${pageKey}`)
      .then(({ data }) => { if (active) { setDoc(data); setLoading(false); } })
      .catch(() => { if (active) { setLoading(false); navigate("/"); } });
    return () => { active = false; };
  }, [pageKey]);

  return (
    <div className="min-h-[60vh]">
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <Button variant="ghost" onClick={() => navigate("/")} data-testid="legal-back-btn" className="mb-6 -ml-2 text-slate-600 hover:text-slate-900">
          <ArrowLeft className="mr-1 h-4 w-4" /> Back to home
        </Button>
        {loading ? (
          <p className="text-slate-400">Loading…</p>
        ) : (
          <>
            <h1 data-testid="legal-title" className="font-heading text-4xl font-bold text-slate-900 sm:text-5xl">
              {doc?.page_title || DEFAULT_TITLES[pageKey]}
            </h1>
            <p className="mt-3 text-sm text-slate-500">Last Updated: August 2026</p>
            <div className="mt-8" data-testid="legal-content"><Markdown text={doc?.content} /></div>
          </>
        )}
      </div>
    </div>
  );
}
